import { useLoadOptions } from "../../../../../hooks/useLoadOptions";

export enum OpcionSiNo {
    Si = 1,
    No = 2
}

export const opcionesSiNo = [
  { id: OpcionSiNo.Si, descripcion: 'Sí' },
  { id: OpcionSiNo.No, descripcion: 'No' }
];

export const useSiNoOptions = () => {
  return useLoadOptions({
    data: opcionesSiNo,
    loading: false,
    isError: false,
    error: null
  });
};

export const loadSiNoOptions = () => Promise.resolve(opcionesSiNo);